export const SEARCH_ROUTES = {
  PURCHASE: '/purchase',
  QUOTE: '/quotes/search',
} as const;
